import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import { Container } from '@mui/material'
import styled from 'styled-components'

import { CertificateStartScreen } from 'src/components/CertificateQuiz/CertificateStartScreen/CertificateStartScreen'
import { PUBLIC_CERTIFICATE_DETAILS_QUERY, PUBLIC_CERTIFICATE_START_MUTATION } from 'src/queries/PublicCertificate'
import { CertificateState, Mutation, MutationStartPublicCertificationArgs, Query, QueryPublicCertificateArgs } from 'src/types/graphql'
import { spacing } from 'src/utils/styled'
import { GenericLoading } from 'src/components/Utils/GenericLoading/GenericLoading'
import { GenericError } from 'src/components/Utils/GenericError/GenericError'

const StyledContainer = styled(Container)`
    margin-top: ${spacing(5)};
`

export function CertificateStartRoute() {
    const { _id } = useParams<{ _id: string }>()
    const navigate = useNavigate()

    const { data, loading, error } = useQuery<Pick<Query, 'publicCertificate'>, QueryPublicCertificateArgs>(
        PUBLIC_CERTIFICATE_DETAILS_QUERY,
        { variables: { _id: _id! } },
    )

    const [startCertification] =
        useMutation<Pick<Mutation, 'startPublicCertification'>, MutationStartPublicCertificationArgs>(PUBLIC_CERTIFICATE_START_MUTATION)

    useEffect(() => {
        switch (data?.publicCertificate?.state) {
            case CertificateState.Failed:
            case CertificateState.Passed: {
                navigate('stats')
                break
            }
            case CertificateState.InProgress: {
                navigate('quiz')
                break
            }
        }
    }, [data?.publicCertificate?.state, navigate])

    const onStart = async () => {
        await startCertification({ variables: { _id: _id! } })
        navigate('quiz')
    }

    return (
        <StyledContainer>
            {loading && <GenericLoading />}
            {error && <GenericError title="Da ist was schiefgelaufen" message={error.message} />}
            {data?.publicCertificate && <CertificateStartScreen certificate={data.publicCertificate} onStart={onStart} />}
        </StyledContainer>
    )
}
